'use strict';

var _ = require('lodash');
var toastr = require('toastr');
function FaresOptimizerSaveAdjustmentsService(saveAdjustedFaresService, dataService, momentService, $q, configurationService) {
  var RBD_LABEL_DEFAULT_CLASS = 'effective-fare-section rbd-label';
  var RBD_LABEL_CLASS_ON_EFFECTIVE_FARE_EDIT = 'effective-fare-section rbd-label-effective-fare-edited';
  var RBD_LABEL_DEFAULT_CLASS_MAPPED = 'effective-fare-section rbd-label-mapped';
  var RBD_LABEL_CLASS_ON_EFFECTIVE_FARE_MAPPED = 'effective-fare-section rbd-label-effective-fare-mapped';
  function saveAdjustments(clonedHostLadder, recommendationEntry, screenState) {
    _.each(clonedHostLadder, function (clonedHostFare) {
      clonedHostFare.effFareClass = 'fare-value effective-fare-section';
      clonedHostFare.minFareThreshold = Math.round(clonedHostFare.minFareThreshold);
      clonedHostFare.maxFareThreshold = Math.round(clonedHostFare.maxFareThreshold);
    });
    var fareInversionExists = saveAdjustedFaresService.fareInversionCheck(clonedHostLadder, recommendationEntry);
    var isFareWithinThreshold = saveAdjustedFaresService.modifiedFareWithinFareThresholdCheck(clonedHostLadder);
    return validateAndPersistAdjustments(fareInversionExists, isFareWithinThreshold, clonedHostLadder, recommendationEntry, screenState);
  }
  function validateAndPersistAdjustments(fareInversionExists, isFareWithinThreshold, clonedHostLadder, recommendationEntry, screenState) {
    if (fareInversionExists) {
      toastr.error('Fare Inversions observed. Please correct and save again');
      return $q.reject();
    }
    if (!isFareWithinThreshold) {
      toastr.error('User fare adjustments not within Min/Max thresholds. Please correct and save again');
      return $q.reject();
    }
    var userAdjustedDates = null;
    var consolidatedUserAdjustedDates = null;
    if (screenState.recommendMode === 'TACTICAL' && !_.isNil(recommendationEntry._userAdjustedDates)) {
      /**                 when is adjusted                                                         when is aligned                              default behavior */
      userAdjustedDates = transformEditedUserAdjustedDates(recommendationEntry._userAdjustedDates) || recommendationEntry.data.userAdjustedDates || null;
      var validAndInvalidRbds = saveAdjustedFaresService.getValidInvalidRbdsAndDates(recommendationEntry, userAdjustedDates);
      if (!_.isEmpty(validAndInvalidRbds.invalidRbds)) {
        toastr.error('Invalid RBD(s) : ' + validAndInvalidRbds.invalidRbds.join(', ') + '. Enter Valid RBD(s): [ ' + validAndInvalidRbds.validRbds.join(' | ') + ' ]');
        return $q.reject();
      }
      if (!_.isEmpty(validAndInvalidRbds.emptyDateFields)) {
        toastr.error('Date fields cannot be empty for RBD(s): [ ' + validAndInvalidRbds.emptyDateFields.join(' | ') + ' ]');
        return $q.reject();
      }
      var tacticalFareDefinitionProperties = screenState.recommendationDetailsPanel.tacticalFareDefinitionData;
      var primaryCriteria = saveAdjustedFaresService.primaryCriteriaCheck(userAdjustedDates, tacticalFareDefinitionProperties, clonedHostLadder);
      if (!primaryCriteria.isPrimaryCheckPassed) {
        var properties = getViolatingPropertyNames(tacticalFareDefinitionProperties);
        toastr.error('Host Primary Criteria Check failed for ' + properties + ' and RBD(s) [ ' + primaryCriteria.failedRbds + ' ]');
        return $q.reject();
      }
      consolidatedUserAdjustedDates = saveAdjustedFaresService.consolidateUserAdjustedDates(clonedHostLadder, userAdjustedDates);
      var overlappingDates = saveAdjustedFaresService.areOverlappingDates(consolidatedUserAdjustedDates);
      if (overlappingDates) {
        toastr.error('Found overlapping dates:- ' + overlappingDates);
        return $q.reject();
      }
    }
    var alignLadderPayload = saveAdjustedFaresService.getAlignLadderPayload(recommendationEntry.recomId, clonedHostLadder, consolidatedUserAdjustedDates);
    screenState.reorderGroupOptions = false;
    return dataService.alignFareRecommendations(alignLadderPayload, screenState.displayedRawData, screenState.rawData);
  }
  function getViolatingPropertyNames(tacticalFareDefinitionProperties) {
    var properties = [];
    _.forEach(tacticalFareDefinitionProperties, function (props) {
      if (props.criteria === 'Reservation End Date (FN)' || props.criteria === 'Ticketing End Date (FN)' || props.criteria === 'Travel End Date (FN)') {
        properties.push(props.criteria);
      }
    });
    return properties.join(', ');
  }
  function transformEditedUserAdjustedDates(userAdjustedDates) {
    var clonedAdjustedDates = userAdjustedDates && _.cloneDeep(_.omit(userAdjustedDates, ['saleDates']));
    var allowedKeys = ['begin', 'end', 'from', 'to', 'complete'];
    _.each(_.keys(clonedAdjustedDates), function (userAdjustedDateKey) {
      _.each(clonedAdjustedDates[userAdjustedDateKey], function (dateRanges) {
        delete dateRanges.isVisible;
        _.each(_.keys(dateRanges), function (dateRangeKey) {
          if (_.includes(allowedKeys, dateRangeKey)) {
            if (momentService.isMoment(dateRanges[dateRangeKey])) {
              dateRanges[dateRangeKey] = dateRanges[dateRangeKey].value.format(momentService.FORMAT.DATE_ISO);
            } else {
              delete dateRanges[dateRangeKey];
            }
          }
        });
      });
    });
    return clonedAdjustedDates;
  }
  function getRegularFbcsFromFareLadder(hostLadder) {
    return _.filter(hostLadder, function (effFare) {
      return _.isNil(effFare.sponsorMarketFbc) && _.isNil(effFare.dualRbdSponsorFbc);
    });
  }
  function getCustomRbdLabelCustomClass(hostFare) {
    if (hostFare.isMappedRbd) {
      return hostFare.recommendedTotalFare === hostFare.effectiveTotalFare ? RBD_LABEL_DEFAULT_CLASS_MAPPED : RBD_LABEL_CLASS_ON_EFFECTIVE_FARE_MAPPED;
    }
    return hostFare.recommendedTotalFare === hostFare.effectiveTotalFare ? RBD_LABEL_DEFAULT_CLASS : RBD_LABEL_CLASS_ON_EFFECTIVE_FARE_EDIT;
  }
  function isUserAuthorizedForCurrentPos(pos) {
    return _.includes(configurationService.getUserPrimaryPOSLevel(), pos) || _.includes(configurationService.getUserLastPOSLevel(), pos);
  }
  return {
    saveAdjustments: saveAdjustments,
    getRegularFbcsFromFareLadder: getRegularFbcsFromFareLadder,
    getCustomRbdLabelCustomClass: getCustomRbdLabelCustomClass,
    isUserAuthorizedForCurrentPos: isUserAuthorizedForCurrentPos
  };
}
FaresOptimizerSaveAdjustmentsService.$inject = ['FaresOptimizerSaveAdjustedFaresService', 'FaresOptimizerAnalysisDataService', 'MomentService', '$q', 'ConfigurationService'];
module.exports = FaresOptimizerSaveAdjustmentsService;